import React, { FunctionComponent, PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

const fonts = {
  heading: 'Poppins, sans-serif',
  body: 'Poppins, sans-serif',
}

const sizes = {
  '2xs': { fontSize: '0.75rem', lineHeight: '1.125rem' },
  xs: { fontSize: '0.75rem', lineHeight: '1.125rem' },
  sm: { fontSize: '1rem', lineHeight: '1.5rem' },
  md: { fontSize: '1.25rem', lineHeight: '1.875rem' },
  lg: { fontSize: '1.563rem', lineHeight: '2.313rem' },
  xl: { fontSize: '1.938rem', lineHeight: '2.875rem' },
  '2xl': { fontSize: '2.438rem', lineHeight: '3.625rem' },
}

const StyledElement = styled.div`
  ${({ fontWeight, size, type, color, caps }: TextProps) => css`
    font-weight: ${fontWeight};
    font-size: ${sizes[size].fontSize};
    line-height: ${sizes[size].lineHeight};
    font-family: ${fonts[type]};
    color: ${color};
    ${caps &&
    css`
      text-transform: uppercase;
    `}
  `}
`

export interface TextProps {
  className?: string
  element: React.ElementType
  type: 'heading' | 'body'
  size: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  fontWeight: 400 | 500 | 600 | 700
  color?: string
  htmlFor?: string
  href?: string
  caps?: boolean
}

export const Text: FunctionComponent<PropsWithChildren<TextProps>> = ({
  children,
  className,
  element,
  type,
  size,
  fontWeight,
  color,
  htmlFor,
  href,
  caps = false,
}) => (
  <StyledElement
    as={element}
    className={className}
    htmlFor={htmlFor}
    type={type}
    size={size}
    fontWeight={fontWeight}
    color={color}
    href={href}
    caps={caps}
  >
    {children}
  </StyledElement>
)
